import React, { useState, useEffect } from 'react';
import AsyncSelect from "react-select/async";
import { decimalAdjust } from '../../Global';
import { BotonAddItem, BotonRemovePequeño } from '../Plantillas/Botones';
import ReactTable from "react-table";
import { notificarError, notificarMsg } from '../Almacenes/AlmacenNotify';


function ListaDetalles(props) {
  return <>
    <ReactTable
      data={props.detalles}
      disabled={false}
      columns={[
        {
          Header: "Producto",
          accessor: "Producto",
          minWidth: 215,
        },
        {
          Header: "Cantidad",
          accessor: "Cantidad",
          maxWidth: 140,
          Cell: row => (
            <div style={{ textAlign: "right" }}>
              <input
                type="number"
                min={0.000001}
                className="form-control form-control-sm"
                style={{ width: "80px", display: "inline-block", textAlign: "right" }}
                value={row.value}
                onChange={e => {
                  const nuevaCantidad = parseInt(e.target.value, 10) || 1;
                  if (typeof row.original.onCantidadChange === "function") {
                    row.original.onCantidadChange(nuevaCantidad, row.original);
                  } else if (typeof props.onCantidadChange === "function") {
                    props.onCantidadChange(nuevaCantidad, row.original);
                  }
                }}
              />
            </div>
          )
        },
        {
          Header: "Precio costo",
          accessor: "PrecioCosto",
          maxWidth: 140,
          Cell: row => <div style={{textAlign: "right"}}>{row.value}</div>
        },
        {
          Header: "Precio de venta",
          accessor: "PrecioVenta",
          maxWidth: 140,
          Cell: row => <div style={{textAlign: "right"}}>{row.value}</div>
        },
        {
          Header: "Margen/Descuento",
          accessor: "Descuento",
          maxWidth: 180,
          Cell: row => {
            const usarMargen = row.original.UsarMargenGanancia !== false; // Por defecto true para nuevos items
            const tipo = usarMargen ? "Margen ganancia (%)" : "Descuento (S/)";
            return (
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: "10px", color: "#666", marginBottom: "2px" }}>
                  {tipo}
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                  <input
                    type="number"
                    min={0}
                    step={0.01}
                    className="form-control form-control-sm"
                    style={{ width: "80px", display: "inline-block", textAlign: "right" }}
                    value={row.value}
                    onChange={e => {
                      const nuevoValor = parseFloat(e.target.value) || 0;
                      if (typeof row.original.onDescuentoChange === "function") {
                        row.original.onDescuentoChange(nuevoValor, row.original);
                      } else if (typeof props.onDescuentoChange === "function") {
                        props.onDescuentoChange(nuevoValor, row.original);
                      }
                    }}
                  />
                  <span style={{ fontSize: "12px", color: "#666", minWidth: "20px" }}>
                    {usarMargen ? "%" : "S/"}
                  </span>
                </div>
              </div>
            )
          }
        },
        {
          Header: "Precio final",
          accessor: "PrecioConDscto",
          maxWidth: 110,
          Cell: row => {
            const usarMargen = row.original.UsarMargenGanancia !== false;
            const precioCosto = row.original.PrecioCosto || 0;
            const precioVenta = row.original.PrecioVenta || 0;
            const valor = row.original.Descuento || 0;
            
            let precioFinal;
            if (usarMargen) {
              // Modo margen de ganancia: Precio Final = PrecioCosto + (PrecioCosto * margenGanancia / 100)
              precioFinal = precioCosto + (precioCosto * valor / 100);
            } else {
              // Modo descuento manual: Precio Final = PrecioVenta - Descuento
              precioFinal = precioVenta - valor;
            }
            
            return <div style={{textAlign: "right"}}>{decimalAdjust('floor', precioFinal, -3)}</div>
          }
        },
        {
          Header: "Acciones",
          accessor: "IdDetalleOC",
          Cell: (f) => {
            return (
              <div align='center'>
                <BotonRemovePequeño
                    title="Eliminar"
                    type='button'
                    className="ml-2"
                    onClick={
                        () => props.onDelete(f.original)
                    }
                />
              </div>
            )
          },
        },
      ]}

      defaultPageSize={20}
      showPagination={true}
      style={{
          height: "890px",
          width: "100%",
          fontSize: "13px"
      }}
      className="-striped -highlight"
    />
  </>
}


export default function(props) {
  const [nombre, setNombre] = useState("");
  const [product, setProduct] = useState(null);
  const [descuento, setDescuento] = useState(0.000000);
  const [precioVenta, setPrecioVenta] = useState(0.000000);
  const [cantidad, setCantidad] = useState(0.000000);
  const [codigoBarras, setCodigoBarraas] = useState("");
  const [detalles, setDetalles] = useState([]);
  const [usarMargenGanancia, setUsarMargenGanancia] = useState(true);

  useEffect(() => {
    if (!props.currentId) {
      return;
    }

    const load = async () => {
      try {
        const req = await fetch(`/api/combos/${props.currentId}`, {
          headers: {
            'Content-Type': 'application/json',
            'Accept-Content': 'application/json',
          }
        });
  
        if (!req.ok) {
          throw new Error();
        }
  
        const combo = await req.json();

        setNombre(combo.Nombre);
        setCodigoBarraas(combo.CodigoBarras)

        let items = [];

        for (const det of combo.detalles) {
          const productos = await searchProduct(det.Producto);

          const p = productos.find(x => x.IdPresentacion == det.IdPresentacion);

          const precios = p.precios;
          const costo = precios.find(x => x.IdPrecioPlantilla == 1);

          if (!p) {
            continue;
          }

          const precioCosto = costo.Precio || 0;
          const descuentoValor = det.Descuento || 0;
          const usarMargen = descuentoValor < 0;
          
          const valorMostrar = usarMargen ? Math.abs(descuentoValor) : descuentoValor;

          items.push({
            IdPresentacion: p.IdPresentacion,
            Producto: p.label,
            Descuento: valorMostrar,
            Cantidad: det.Cantidad,
            PrecioVenta: p.precio,
            PrecioCosto: precioCosto,
            UsarMargenGanancia: usarMargen,
          })
        }

        setDetalles(items);
      } catch (e) {
        console.error(e)
        notificarError("No se puede obtener información en este momento. Intentelo en unos minutos.")
        props.onCancel();
      }
    }

    load();
    
  }, [props.currentId])

  const searchProduct = async (search) => {
    let products = []

    try {
      const req = await fetch(`/api/preVentas/?search=${search}&idTipoStock=1`);

      if (!req.ok) {
        throw new Error(await req.text())
      }

      const response = await req.json()

      products = response.productos.map((p) => {
        return {
          ...p,
          label: `${p.descripcion} ${p.unidadMedida}`,
          value: p.IdPresentacion
        }
      });
    } catch (e) {
      console.error(e)
    }

    return products;
  }

  const onChooseProduct = (p) => {
    setCantidad(1);
    setPrecioVenta(p.precio)
    setProduct(p);

    if (p.precios) {
      const costo = p.precios.find(x => x.IdPrecioPlantilla == 1);
      if (costo) {
        p.PrecioCosto = costo.Precio;
      }
    }

    const fieldName = usarMargenGanancia ? "margen-ganancia" : "descuento";
    setTimeout(() => {
      const field = document.querySelector("#combo-form")?.querySelector(`[name=${fieldName}]`);
      if (field) field.focus();
    }, 100);
  }

  const onAgregarItem = () => {
    const alreadyExists = detalles.find(x => x.IdPresentacion == product.IdPresentacion);

    if (alreadyExists) {
      notificarError("El producto ya se encuentra registrado.")
      return;
    }

    let precioCosto = 0;
    if (product.precios) {
      const costo = product.precios.find(x => x.IdPrecioPlantilla == 1);
      if (costo) {
        precioCosto = costo.Precio;
      }
    }

    setDetalles([...detalles, {
      IdPresentacion: product.IdPresentacion,
      Producto: product.label,
      Descuento: descuento,
      Cantidad: cantidad,
      PrecioVenta: product.precio,
      PrecioCosto: precioCosto,
      UsarMargenGanancia: usarMargenGanancia,
    }])

    setCantidad(1);
    setPrecioVenta(0);
    setProduct(null);
  }

  const onCancel = () => {
    props.onCancel();
  }
  
  const onSubmit = async () => {
    if (detalles.length == 0) {
      notificarError("Se debe asignar al menos un producto.")
      return;
    }

    try {
      const url = !!props.currentId ? `/api/combos/${props.currentId}` : `/api/combos`

      const req = await fetch(url, {
        method: !!props.currentId ? "PUT" : "POST",
        body: JSON.stringify({
          Nombre: nombre,
          CodigoBarras: codigoBarras,
          Detalles: detalles.map((d) => {
            // Convención: guardar como negativo si es margen de ganancia
            const usarMargen = d.UsarMargenGanancia !== false;
            const descuentoAGuardar = usarMargen ? -Math.abs(d.Descuento) : Math.abs(d.Descuento);
            
            return {
              IdPresentacion: d.IdPresentacion,
              Descuento: descuentoAGuardar,
              Cantidad: d.Cantidad,
            };
          })
        }),
        headers: {
          'Content-Type': 'application/json',
          'Accept-Content': 'application/json',
        }
      });

      if (!req.ok) {
        throw new Error()
      }

      notificarMsg("Se guardaron los cambios correctamente.")

      props.onCancel();

    } catch (e) {
      notificarError("No se pudo registrar el combo. Inténtalo otra vez.")
      console.error(e);
    }
  }

  const onDelete = (detalle) => {
    const newDetalles = detalles.filter(x => x.IdPresentacion != detalle.IdPresentacion);
    setDetalles(newDetalles);
  }

  const onCantidadChange = (cantidad, detalle) => {
    const newDetalles = detalles.map(x => x.IdPresentacion == detalle.IdPresentacion ? { ...x, Cantidad: cantidad } : x);
    setDetalles(newDetalles);
  }

  const onDescuentoChange = (descuento, detalle) => {
    const newDetalles = detalles.map(x => x.IdPresentacion == detalle.IdPresentacion ? { ...x, Descuento: descuento } : x);
    setDetalles(newDetalles);
  }

  return <>
    <div id="combo-form" className="container">
      <div className="row">
        <div className="col-12 border-bottom">
          <div className="form-group">
            <label htmlFor="nombre">Nombre: </label>

            <input
              className="form-control"
              name="nombre"
              type="text"
              placeholder="Ingrese un nombre para el combo..."
              onChange={e => setNombre(e.target.value)}
              value={nombre}
              autoComplete="off"
            />
          </div>
        </div>

        <div className="col-12 mt-2">
          <div className="form-group">
            <label>Codigo barras:</label>
            <input
              className="form-control"
              name="codBarras"
              type="text"
              placeholder="Ingrese un codigo de barras para el combo..."
              onChange={e => setCodigoBarraas(e.target.value)}
              value={codigoBarras}
              autoComplete="off"
            />
          </div>
        </div>

        <div className="col-12 mt-2">
          <div className="form-group">
            <label>Buscar producto:</label>
            <AsyncSelect
              isClearable={true}
              onChange={(p) => onChooseProduct(p)}
              value={product}
              loadOptions={searchProduct}
            />
          </div>
        </div>

        <div className="col-12">
          <div className="form-group">
            <label htmlFor="descuento">Cantidad: </label>

            <input 
              className='form-control'
              type='number'
              name='cantidad'
              min={0}
              max={10000}
              step={1}
              onChange={(e) => setCantidad(Number(e.target.value))}
              value={decimalAdjust('floor', cantidad, -6)}

            />
            {/* <NumericInput
              className="form-control"
              name="cantidad"
              min={0}
              max={10000}
              step={1}
              type="number"
              onChange={val => setCantidad(val)}
              value={decimalAdjust('floor', cantidad, -6)}
            /> */}
          </div>
        </div>

        <div className="col-4">
          <div className="form-group">
            <label htmlFor="precio-venta">Precio de venta: </label>

            <input
              className='form-control'
              name='precio-venta'
              type='number'
              min={0}
              max={10000}
              step={1}
              value={decimalAdjust('floor', precioVenta, -6)}
              disabled
            />
            {/* <NumericInput
              className="form-control"
              name="precio-venta"
              min={0}
              max={10000}
              step={1}
              type="number"
              value={decimalAdjust('floor', precioVenta, -6)}
              disabled
            /> */}
          </div>
        </div>

        <div className="col-12 mt-2">
          <div className="form-group">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="usar-margen-ganancia"
                checked={usarMargenGanancia}
                onChange={(e) => {
                  setUsarMargenGanancia(e.target.checked);
                  setDescuento(0);
                }}
              />
              <label className="form-check-label" htmlFor="usar-margen-ganancia">
                Usar margen de ganancia (en lugar de descuento manual)
              </label>
            </div>
          </div>
        </div>

        <div className="col-4">
          <div className="form-group">
            <label htmlFor="precio-costo">Precio de costo: </label>

            <input
              className='form-control'
              name='precio-costo'
              type='number'
              min={0}
              max={10000}
              step={0.01}
              value={decimalAdjust('floor', product?.PrecioCosto || 0, -6)}
              disabled
            />
          </div>
        </div>

        {usarMargenGanancia ? (
          <>
            <div className="col-4">
              <div className="form-group">
                <label htmlFor="margen-ganancia">Margen de ganancia (%): </label>

                <input
                  className='form-control'
                  type='number'
                  name='margen-ganancia'
                  min={0}
                  max={10000}
                  step={0.01}
                  onChange={(e) => setDescuento(Number(e.target.value))}
                  value={decimalAdjust('floor', descuento, -6)}
                />
              </div>
            </div>

            <div className="col-4">
              <div className="form-group">
                <label htmlFor="precio-final">Precio final: </label>

                <input
                  className='form-control'
                  name='precio-final'
                  type='number'
                  value={(() => {
                    const precioCosto = product?.PrecioCosto || 0;
                    const margenGanancia = descuento || 0;
                    return decimalAdjust('floor', precioCosto + (precioCosto * margenGanancia / 100), -3);
                  })()}
                  disabled
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="col-4">
              <div className="form-group">
                <label htmlFor="descuento">Descuento (S/): </label>

                <input
                  className='form-control'
                  type='number'
                  name='descuento'
                  min={0}
                  max={10000}
                  step={0.01}
                  onChange={(e) => setDescuento(Number(e.target.value))}
                  value={decimalAdjust('floor', descuento, -6)}
                />
              </div>
            </div>

            <div className="col-4">
              <div className="form-group">
                <label htmlFor="precio-final">Precio final: </label>

                <input
                  className='form-control'
                  name='precio-final'
                  type='number'
                  value={decimalAdjust('floor', precioVenta - descuento, -3)}
                  disabled
                />
              </div>
            </div>
          </>
        )}

        <div className="col-12 d-flex justify-content-end">
          <BotonAddItem
            title="Agregar item"
            type="button"
            onClick={onAgregarItem}
          />
        </div>

        <div className="col-12 mt-3">
          <ListaDetalles detalles={detalles} onDelete={onDelete} onCantidadChange={onCantidadChange} onDescuentoChange={onDescuentoChange}/>

          <br />

          <div className="w-100 d-flex justify-content-between">
            <span className="font-weight-bold">Cantidad de items: {detalles.length}</span>
            <span className="font-weight-bold">Total: S/ {decimalAdjust('floor', detalles.reduce((acc, curr) => {
              const usarMargen = curr.UsarMargenGanancia !== false;
              const precioCosto = curr.PrecioCosto || 0;
              const precioVenta = curr.PrecioVenta || 0;
              const valor = curr.Descuento || 0;
              
              let precioFinal;
              if (usarMargen) {
                precioFinal = precioCosto + (precioCosto * valor / 100);
              } else {
                precioFinal = precioVenta - valor;
              }
              
              return precioFinal * curr.Cantidad + acc;
            }, 0), -2)}</span>
          </div>
          
        </div>

        <div className="col-12 mt-3 d-flex justify-content-center">
          <button type="button" className="btn btn-secondary mr-2" onClick={onCancel}>Cancelar</button>
          <button type="button" className="btn btn-info" onClick={onSubmit}>Guardar cambios</button>
        </div>
      </div>
    </div>
  </>
}
